// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1wSt8","insightsList":"newBusinessInsightsMenu_insightsList__1kuRg","active":"newBusinessInsightsMenu_active__2fd8B"};